import React, {ReactElement} from 'react';

import {LinkProp} from '../../../types';
import DynamicLink from '../../DynamicLink/DynamicLink';

interface Props {
  links: LinkProp[];
}

// not documented in story book as it is a tightly coupled dependency of WantToKnowMore
function SectionContent({links}: Props): ReactElement {
  return (
    <ul>
      {links.map((mapLink) => {
        return (
          <li key={mapLink.href}>
            {/* @todo revert to Link once all knowledge pages are transferred for NL */}
            <DynamicLink href={mapLink.href} className="wantToKnowMore__link">
              {mapLink.label}
            </DynamicLink>
          </li>
        );
      })}
    </ul>
  );
}

export default SectionContent;
